import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=5d773603&scoped=true"
import script from "./ArticleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=5d773603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d773603",
  null
  
)

export default component.exports